const NawyERealtyLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M12.7817 6.68962C9.53081 5.52348 6.70443 3.46706 4.61317 0.821289H0.728505C0.728505 0.909063 0.722168 0.990568 0.722168 1.07834C0.722168 11.0721 8.9161 19.1786 19.0175 19.1786C19.1062 19.1786 19.1886 19.1724 19.2773 19.1724V15.6113C16.2672 13.3981 13.9731 10.2946 12.7817 6.68962Z"
        fill="#68B6AA"
      />
      <path
        d="M19.277 7.76172V0.821289H4.61279C7.95881 5.047 13.168 7.768 19.0171 7.768C19.1058 7.768 19.1882 7.76172 19.277 7.76172Z"
        fill="#BCDED9"
      />
      <path
        d="M19.2778 15.6175V0.821289H11.8887C11.8887 0.909063 11.8823 0.990568 11.8823 1.07834C11.8823 7.03445 14.7911 12.3197 19.2778 15.6175Z"
        fill="white"
      />
    </svg>
  );
};

export default NawyERealtyLogo;
